import Vue from 'vue'
// 引入组件
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import router from './router'
import App from './App.vue'
Vue.use(ElementUI);
Vue.config.productionTip = false
//配置axios,设置默认请求接口地址
// import axios from 'axios'
// axios.defaults.baseURL = "https://zxwl.uzxkj.com/advertisement/user_equ" 
// Vue.prototype.$axios = axios
new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
